/* 사용자 페이지 관련 시작 */
export const UserAdminPath = [
  { label: "홈", href: "/admin" },
  { label: "회원", href: "/admin/users" },
  { label: "회원" },
];
export const UserAdminTitle = UserAdminPath[UserAdminPath.length - 1].label;
/* 사용자 페이지 관련 끝 */

/* 사용자 관련 시작 */
export const UserStates = [
  { key: "active", value: "활성" },
  { key: "inactive", value: "차단" },
  { key: "delete", value: "삭제" },
];
export const UserState = (state: any) => {
  const object = UserStates.find((item) => item.key === state.toString());
  return object?.value ?? state;
};

export const UserProviders = [
  { key: "email", value: "이메일" },
  { key: "kakao", value: "카카오" },
  { key: "apple", value: "애플" },
];
export const UserProvider = (state: any) => {
  const object = UserProviders.find((item) => item.key === state.toString());
  return object?.value ?? state;
};

export const UserRoles = [
  { key: "admin", value: "관리자" },
  { key: "user", value: "회원" },
];
export const UserRole = (state: any) => {
  const object = UserRoles.find((item) => item.key === state.toString());
  return object?.value ?? state;
};
/* 사용자 관련 끝 */
